import { alpha, type SxProps, type Theme } from "@mui/material/styles";

import { borderRadius, shadows } from "design-tokens";

export const PAGE_SX: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  flex: 1,
  minHeight: 0,
  minWidth: 0,
  overflow: "hidden",
  pl: 1.25,
  ml: -1.25,
};

export const HEADER_SX: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  flexShrink: 0,
  pt: 2,
};

export const TITLE_GROUP_SX: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  gap: 1.5,
};

/** 24/30/700 matches no theme variant, and `h2` would step up to a 30px font at `sm`. */
export const TITLE_SX: SxProps<Theme> = (theme) => ({
  fontSize: "1.5rem",
  lineHeight: "30px",
  fontWeight: 700,
  color: theme.palette.secondary.main,
});

export const ACTIONS_SX: SxProps<Theme> = {
  display: "flex",
  gap: 1.5,
};

export const STATUS_ROW_SX: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  gap: 1.5,
  pb: 1.5,
};

export const DUE_DATE_SX: SxProps<Theme> = (theme) => ({
  display: "flex",
  alignItems: "center",
  gap: 1,
  px: 1.5,
  py: 0.75,
  borderRadius: borderRadius.md,
  backgroundColor: alpha(theme.palette.warning.main, 0.2),
  color: theme.palette.warning.dark,
  boxShadow: shadows.xs,
  ...theme.typography.body2,
  fontWeight: 600,
});

export const DESCRIPTION_SX: SxProps<Theme> = { whiteSpace: "pre-wrap" };
